// @mui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Typography } from '@mui/material';
import ContactHero from '../contact-hero';
import ContactForm from '../contact-form';
import ContactMap from '../contact-map';

// ----------------------------------------------------------------------

export default function ContactView() {
  return (
    <>
      <ContactHero />

      <Container sx={{ py: 6 }}>
        <Box
          gap={6}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          }}
        >
          <ContactForm />

          <Box>
            {/* Add here information about the business location like address, phone number, email, etc. */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6">Contact Us</Typography>
              <Typography variant="body1">
                Address: Sin el fil, Choucair group center, 8th floor, Beirut, Lebanon
              </Typography>
              <Typography variant="body1">Phone: +961 81 729436</Typography>
              <Typography variant="body1">Email: support@cartifyapp.ai</Typography>
            </Box>
            <ContactMap />
          </Box>
        </Box>
      </Container>
    </>
  );
}
